import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { SearchableMenuContext } from './SearchableMenuContext';
export function SearchableMenuProvider(props) {
    const { items, initiallyOpen = false, onClose, onReset, onSearch, children, error = false, loading = false } = props;
    const [open, setOpen] = useState(initiallyOpen);
    const [active, setActive] = useState(false);
    const [searchString, setSearchString] = useState('');
    const [internalLoading, setInternalLoading] = useState(loading);
    const isLoading = loading || internalLoading;
    const resetSearch = () => {
        setActive(false);
        onReset();
        setSearchString('');
    };
    const debouncedSearch = useDebouncedCallback(() => {
        if (searchString === '') {
            onReset();
        }
        const trimmedSearch = searchString.trim();
        if (trimmedSearch.length >= 2) {
            onSearch(trimmedSearch);
            setActive(true);
        }
        setInternalLoading(false);
    }, 250);
    useEffect(() => {
        setInternalLoading(true);
        debouncedSearch();
    }, [searchString, debouncedSearch]);
    const hasResult = Boolean(items.length);
    const handleSetOpen = (newState) => {
        setOpen(newState);
        if (newState) {
            resetSearch();
        }
        if (!newState && onClose) {
            onClose();
        }
    };
    const value = {
        open,
        setOpen: handleSetOpen,
        searching: active,
        hasResult,
        items,
        handleSearch: setSearchString,
        resetSearch,
        searchString,
        error,
        loading: isLoading,
    };
    return <SearchableMenuContext.Provider value={value}>{children}</SearchableMenuContext.Provider>;
}
